import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sourceMode: localStorage.getItem("sourceMode") === "true",
  recordMode: localStorage.getItem("recordMode") === "true",
  streamMode: localStorage.getItem("streamMode") === "true",
  vMixApi: localStorage.getItem("vMixApi") === "true",
  mixerApi: localStorage.getItem("mixerApi") === "true",
  vCam: localStorage.getItem("vCam") === "true",
  obs: localStorage.getItem("obs") === "true",
};

export const vMixButtonSlice = createSlice({
  name: "vMixButton",
  initialState,
  reducers: {
    setSourceMode: (state, action) => {
      state.sourceMode = action.payload;
    },
    setRecordMode: (state, action) => {
      state.recordMode = action.payload;
    },
    setStreamMode: (state, action) => {
      state.streamMode = action.payload;
    },
    setVMixApp: (state, action) => {
      state.vMixApi = action.payload;
    },
    setMixerApp: (state, action) => {
      state.mixerApi = action.payload;
    },
    setVCam: (state, action) => {
      state.vCam = action.payload;
    },
    setObsStatus: (state, action) => {
      state.obs = action.payload;
    },
  },
});

export const { setRecordMode, setSourceMode, setStreamMode, setVMixApp, setMixerApp, setVCam, setObsStatus } = vMixButtonSlice.actions;

export default vMixButtonSlice.reducer;
